import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { StatusesEnums } from 'dashboard-services/api/statuses';
import { CommonService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { StatusesBox } from 'primary-components';

const StatusBox = ({ ...props }) => {
  const { pathname } = useLocation(),
        navigate = useNavigate(),
        openItem = useCallback((type, params) => {
          const baseUrl = window.location.origin
          switch (type) {
            case StatusesEnums.STATUS_TYPE.PIPELINE: {
              CommonService.openInNewTab(DashboardLinkFactory.dataScience.pipeline({ baseUrl, groupName: params.groupName, pipelineName: params.pipelineName, version: params.version, jobId: params.jobId }))
              break
            }
            case StatusesEnums.STATUS_TYPE.DATAPREP: {
              CommonService.openInNewTab(DashboardLinkFactory.dataStorage.dataPrep({ baseUrl, groupName: params.groupName, includeQuery: false, jobId: params.jobId, name: params.dataprepName, version: params.version }))
              break
            }
            default:
            case StatusesEnums.STATUS_TYPE.ETL: {
              if (pathname.startsWith("/Lake")) {
              navigate(DashboardLinkFactory.dataLake.file({ baseUrl: "", fileId: params.fileId }))
              } else {
                CommonService.openInNewTab(DashboardLinkFactory.dataLake.group({ baseUrl, groupName: params.groupName, query: params.fileId }))
              }
              break
            }
          }
        }, [navigate, pathname])
  return (
    <StatusesBox
        {...props}
        openItem={openItem}
    />
  )
}

export default StatusBox
